import React, { useMemo } from 'react';
import ReactHtmlParse from 'react-html-parser';
import { 
  TestimonialsContainer, 
  TestimonialsContent, 
  TestimonialsDescription, 
  TestimonialsHeading, 
  TestimonialsImage, 
  TestimonialsSlider,
  WinnerCard
} from 'raffle-house-uikit';
import RaffleButton from '../common/RaffleButton';

import './styles.scss';

const parseDescription = (description) => {
  if (description && !/^<p>.*<\/p>$/.test(description)) {
    description = `<p>${description}</p>`;
  }
  return ReactHtmlParse(description);
};

export default function Testimonials({ winners, onMoreWinnersClick }) {
  const slides = useMemo(() => {
    return winners.reduce((slides, winner, index) => {
      // if (winner.photoUrl) {
        const slide = (
          <div className='testimonials-winner-card' key={index}>
            <WinnerCard
              winner={winner}
              production={process.env.REACT_APP_ENV === 'production'}
            />
          </div>
        );
        return [...slides, slide];
      // }
      return slides;
    }, []);
  }, [winners]);

  return (
    <TestimonialsContainer>
      <TestimonialsContent>
        <TestimonialsHeading>Be our next winner</TestimonialsHeading>
        <TestimonialsDescription>Trusted since 2018.</TestimonialsDescription>
        <TestimonialsSlider slides={slides}/>
      </TestimonialsContent>
      <RaffleButton
        variant="secondary"
        size="extra"
        onClick={onMoreWinnersClick}
      >
        More winners
      </RaffleButton>
      <TestimonialsImage placement='top-right' src={`${process.env.REACT_APP_AWS_S3_URL}testimonials/testimonial-image-1.png`} />
      <TestimonialsImage placement='bottom-left' src={`${process.env.REACT_APP_AWS_S3_URL}testimonials/testimonial-image-2.png`} />
    </TestimonialsContainer>
  )
}
